module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Vice.fb6d08b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Vice.jpg
// module id = N3h/
// module chunks = 0